export const MAINPAGE_URL = "https://careerfit.com";
